import { graphql } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';

const mutation = graphql`
    mutation editUserPreferencesMutation($input: EditUserPreferencesInput!) {
        editUserPreferences(input: $input) {
            user {
                preferences {
                    shareActivities
                }
            }
        }
    }
`;

export function editUserPreferencesMutation(environment, input) {
    return commitMutation(environment, { mutation, variables: { input } });
}
